<template>
  <section v-if="value" class="map-section">
    <div class="info">
      <h5 class="info__title">{{ $t('offices-page.map-title') }}</h5>
      <button class="toggle-btn" @click="$emit('input', false)">
        {{ $t('offices-page.close-map-btn') }}
      </button>
    </div>
    <img :src="require(`~/assets/img/maps/${img}.png`)" alt="" class="map">
  </section>
</template>

<script>
export default {
  name: 'ContactsMap',

  props: {
    value: {
      type: Boolean,
      default: false,
    },

    img: {
      type: String,
      default: 'office',
    },
  },
};
</script>

<style scoped lang="scss">
.map {
  width: 100%;
  height: 400px;
  object-fit: cover;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;

  @include desktop {
    height: 600px;
  }
}

.map-section {
  overflow: hidden;
  margin-top: -1rem;
  background: color(default);
  border-radius: 0.5rem;
}

.info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 1rem;

  @include mobile {
    padding: 0 1rem 1rem;
  }

  &__title {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    padding: 0;
  }
}

.toggle-btn {
  text-transform: uppercase;
  cursor: pointer;
  color: color(secondary);
  font-weight: 700;
  background: transparent;
  border: 1px solid color(secondary);
  border-radius: 0.5rem;
  padding: 0.5rem;
}
</style>
